module.exports = "/_next/static/images/macpunks-roadmap-bg-fda90e6dc17307bad7ff8b5a433f6107.png";